import { FC, ReactNode, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { SectionHeader } from '../common/SectionHeader';
import { ContentWrapperColumn } from '../layout/commonLayout';
import { QcsTabs } from '../common/basic/QcsTabs';
import { IntegrationApiClients } from './IntegrationApiClients';
import { IntegrationVisitSettings } from './IntegrationVisitSettings';

//The id is also the URL segment, so every tab can be linked to directly as /integration/<id>.
type IntegrationTabId = 'api-access' | 'settings';

interface IntegrationTab {
  id: IntegrationTabId;
  label: string;
  content: ReactNode;
}

export const Integration: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { tabId } = useParams<{ tabId: IntegrationTabId }>();

  const tabs: IntegrationTab[] = [
    { id: 'api-access', label: t('integration.apiAccess.title'), content: <IntegrationApiClients /> },
    { id: 'settings', label: t('integration.settings.title'), content: <IntegrationVisitSettings /> },
  ];

  const activeTab = tabs.find((tab) => tab.id === tabId) ?? tabs[0];

  return (
    <ContentWrapperColumn>
      <SectionHeader title="mainMenu.integration" />
      <QcsTabs tabs={tabs} value={activeTab.id} onChange={(_: SyntheticEvent, id: IntegrationTabId) => navigate(`/integration/${id}`)} />
      {activeTab.content}
    </ContentWrapperColumn>
  );
};
